import { getUserFacingApiMessage } from "./getUserFacingApiMessage";
import { can } from "../hooks/useEffectivePermissions";

/** Pode exibir o botão de encerrar sessão de outro usuário (alinha à API). */
export function canOfferForceLogoutOthers({ isMaster, scopeSet, selfId, targetId }) {
  const tid = Number(targetId);
  const sid = Number(selfId);
  if (!Number.isFinite(tid) || tid <= 0) return false;
  if (Number.isFinite(sid) && sid > 0 && tid === sid) return false;
  if (isMaster) return true;
  if (!scopeSet) return false;
  return can(scopeSet, "users", "update");
}

/** Mensagem + orientação para o diálogo de encerrar sessão. */
export function formatForceLogoutError(error, fallbackMessage) {
  const u = getUserFacingApiMessage(error);
  const main = u.message || fallbackMessage;
  if (u.action) return `${main}\n\n${u.action}`;
  return main;
}
